import { mapState, mapGetters } from 'vuex';
import orderStatusMixin from '@shared/mixins/orderStatusMixin';
import formatterMixin from '@shared/mixins/formatterMixin';

const partnerOrderMixin = {
  mixins: [orderStatusMixin, formatterMixin],
  computed: {
    ...mapState({
      corporation: (state) => state.admin.corporation,
      partnerOrderTableOptions: (state) => state.partnerOrder.partnerOrderTableOptions,
      selectedCorp: (state) => state.partnerOrder.selectedCorp,
      loadingPartnerOrder: (state) => state.partnerOrder.loadingOrder,
      partnerOrderTableSearch: (state) => state.partnerOrder.partnerOrderTableSearch,
    }),
    ...mapGetters([
      'allBranches',
      'poTableRecordCount',
      'poTableData',
      'adminRole',
    ]),
  },
  methods: {
    changePartner(corpId) {
      this.$store.dispatch('getOrdersForPartner', { corpId });
    },
  },
};

export default partnerOrderMixin;
